// // // import Link from "next/link";
// // // import { useState } from "react";
// // // import { useRouter } from "next/router";
// // // //import opti from "/images/optic.png";
// // // import opti from "../images/optic.png";
// // // import Image from "next/image";
// // // import { CgProfile } from "react-icons/cg";
// // // import profile from "../images/profile.svg";

// // // export default function Layout({ children }) {
// // //   const router = useRouter();
// // //   const [isHovered, setIsHovered] = useState(false);
// // //   const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

// // // const menuItems = [
// // //   {
// // //     href: "/getallclientusers",
// // //     title: "Client Users",
// // //     subTags: ["/addclientuser","/edituser","/resetpasswordbyadmin","/changeclientuserpassword" ],

// // //   },
// // //   {
// // //     href: "/getAllConfig",
// // //     title: "Configuration",
// // //     subTags: ["/addconfig","/editconfig", ],

// // //   },
// // //   {
// // //     href: "/getallrules",
// // //     title: "Rules",
// // //     subTags: ["/addrule","/editpercentage","/editdynamic","/editstaticEwt","/editstaffinggeneral" ,"/editstaffing","/adduploadrule"],

// // //   },
// // //   {
// // //     href: "/getuploadconfig",
// // //     title: "Upload Config",
// // //     subTags: ["/addftp","/addazure","/addaws","/editftp","/editazure","/editaws" ],

// // //   },
// // //   {
// // //     href: "/getallforms",
// // //     title: "Forms",
// // //     subTags: ["/addqualityform","/editform" ],

// // //   }, {
// // //     href: "/getallint",
// // //     title: "ALL Interactions",
// // //     subTags: ["/playaudio","/scoring" ],

// // //   },
// // // ];

// // //   const unmenu = [

// // //   ];

// // //   const profilemenu = [
// // //     {
// // //       title1: <Image src={profile} className="imagepmlogo" alt="Profile Image" />,
// // //       className: "profile-menu-item",
// // //       dropdownItems: [
// // //         {
// // //           title: "Change Password",
// // //           href: "/resetpassword",
// // //         },
// // //         {
// // //           title: "Logout",
// // //           href: "/",
// // //         },
// // //       ],
// // //     },
// // //   ];

// // //   const isMenuItemActive = (href) => {
// // //     if (router.asPath === href) return true;
// // //     if (isProfileMenuActive()) return false;
// // //     const menuItem = menuItems.find((item) => item.href === href);
// // //     if (menuItem && menuItem.subTags) {
// // //       return menuItem.subTags.some(subTag => router.asPath.startsWith(subTag));
// // //     }
// // //     return false;
// // //   };

// // //   const isProfileMenuActive = () => {
// // //     return profilemenu.some(({ dropdownItems }) => {
// // //       if (!dropdownItems) return false;
// // //       return dropdownItems.some(({ href }) => router.asPath === href);
// // //     });
// // //   };

// // //   const handleLogout = () => {
// // //     localStorage.clear();
// // //     sessionStorage.clear();
// // //     router.push("/");
// // //   };

// // //   return (
// // //     <div className="minscreen">
// // //       <header className="headercss">
// // //         <Image src={opti} className="imagelogo" alt="Opti Image" />
// // //         <ul className="dashboardcontents">
// // //           {menuItems.map(({ href, title }) => (
// // //             <li className={`titlelist ${isMenuItemActive(href) && "active"}`} key={href}>
// // //               <Link href={href} legacyBehavior>
// // //                 <a className="spantitle">{title}</a>
// // //               </Link>
// // //             </li>
// // //           ))}
// // //         </ul>

// // //         <ul className="dashboardcontents"  >
// // //           {unmenu.map(({ href, title }) => (
// // //             <li
// // //               className={`untitlelist ${isMenuItemActive(href) && "active"}`}
// // //               key={href}
// // //             >
// // //               <Link href={href} legacyBehavior>
// // //                 <a className="unspantitle">{title}</a>
// // //               </Link>
// // //             </li>
// // //           ))}
// // //         </ul>
// // //         <ul className="dashboardcontents"  >
// // //           {unmenu.map(({ href, title }) => (
// // //             <li
// // //               className={`untitlelist ${isMenuItemActive(href) && "active"}`}
// // //               key={href}
// // //             >
// // //               <Link href={href} legacyBehavior>
// // //                 <a className="unspantitle">{title}</a>
// // //               </Link>
// // //             </li>
// // //           ))}
// // //         </ul>
// // //         <ul className="dashboardcontents"  >
// // //           {unmenu.map(({ href, title }) => (
// // //             <li
// // //               className={`untitlelist ${isMenuItemActive(href) && "active"}`}
// // //               key={href}
// // //             >
// // //               <Link href={href} legacyBehavior>
// // //                 <a className="unspantitle">{title}</a>
// // //               </Link>
// // //             </li>
// // //           ))}
// // //         </ul>

// // //         <div className="profile-menu-container">
// // //           <ul className="dashboardlogout">
// // //             <div>
// // //               {profilemenu.map(({ title1, className, dropdownItems }) => (
// // //                 <li className={`titlelogoutlist`} key={title1}>
// // //                   <div className="profile-menu">
// // //                     <span onMouseOver={() => setIsProfileMenuOpen(!isProfileMenuOpen)}>{title1}</span>
// // //                     {isProfileMenuOpen && (
// // //                       <ul className="dropdown-menu">
// // //                         {dropdownItems.map(({ title, href }) => (
// // //                           <li key={href}>
// // //                             <Link href={href} legacyBehavior>
// // //                               <a onClick={href === "/" ? handleLogout : null}>{title}</a>
// // //                             </Link>
// // //                           </li>
// // //                         ))}
// // //                       </ul>
// // //                     )}
// // //                   </div>
// // //                 </li>
// // //               ))}
// // //             </div>
// // //           </ul>
// // //         </div>
// // //       </header>
// // //       <div className={`${isHovered ? "hovered" : ""}`}>
// // //         <nav></nav>
// // //         <main className="flex-1">{children}</main>
// // //       </div>
// // //       <footer className="footer">Copyright © 2026 OPTICENT</footer>
// // //     </div>
// // //   );
// // // }

// // import Link from "next/link";
// // import { useState } from "react";
// // import { useRouter } from "next/router";
// // //import opti from "/images/optic.png";
// // //import opti from "../images/optic.png";
// // import Image from "next/image";
// // import { CgProfile } from "react-icons/cg";
// // import profile from "../images/profile.svg";

// // export default function Layout({ children }) {
// //   const router = useRouter();
// //   const [isHovered, setIsHovered] = useState(false);
// //   const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

// //   const menuItems = [
// //     {
// //       href: "/getallclientusers",
// //       title: "Client Users",
// //       subTags: [
// //         "/addclientuser",
// //         "/edituser",
// //         "/resetpasswordbyadmin",
// //         "/changeclientuserpassword",
// //       ],
// //     },
// //     {
// //       href: "/getAllConfig",
// //       title: "Configuration",
// //       subTags: ["/addconfig", "/editconfig"],
// //     },
// //     {
// //       href: "/getallrules",
// //       title: "Rules",
// //       subTags: [
// //         "/addrule",
// //         "/editpercentage",
// //         "/editdynamic",
// //         "/editstaticEwt",
// //         "/editstaffinggeneral",
// //         "/editstaffing",
// //         "/adduploadrule",
// //       ],
// //     },
// //     {
// //       href: "/getuploadconfig",
// //       title: "Upload Config",
// //       subTags: [
// //         "/addftp",
// //         "/addazure",
// //         "/addaws",
// //         "/editftp",
// //         "/editazure",
// //         "/editaws",
// //       ],
// //     },
// //     {
// //       href: "/getallforms",
// //       title: "Forms",
// //       subTags: ["/addqualityform", "/editform"],
// //     },
// //     {
// //       href: "/getallint",
// //       title: "ALL Interactions",
// //       subTags: ["/playaudio", "/scoring"],
// //     },
// //   ];

// //   const unmenu = [];

// //   const profilemenu = [
// //     {
// //       title1: (
// //         <Image src={profile} className="imagepmlogo" alt="Profile Image" />
// //       ),
// //       className: "profile-menu-item",
// //       dropdownItems: [
// //         {
// //           title: "Change Password",
// //           href: "/resetpassword",
// //         },
// //         {
// //           title: "Logout",
// //           href: "/",
// //         },
// //       ],
// //     },
// //   ];

// //   const isMenuItemActive = (href) => {
// //     if (router.asPath === href) return true;
// //     if (isProfileMenuActive()) return false;
// //     const menuItem = menuItems.find((item) => item.href === href);
// //     if (menuItem && menuItem.subTags) {
// //       return menuItem.subTags.some((subTag) =>
// //         router.asPath.startsWith(subTag),
// //       );
// //     }
// //     return false;
// //   };

// //   const isProfileMenuActive = () => {
// //     return profilemenu.some(({ dropdownItems }) => {
// //       if (!dropdownItems) return false;
// //       return dropdownItems.some(({ href }) => router.asPath === href);
// //     });
// //   };

// //   const handleLogout = () => {
// //     localStorage.clear();
// //     sessionStorage.clear();
// //     router.push("/");
// //   };

// //   return (
// //     <div className="minscreen">
// //       <header className="headercss">
// //         {/* <Image src={opti} className="imagelogo" alt="Opti Image" /> */}
// //         <ul className="dashboardcontents">
// //           {menuItems.map(({ href, title }) => (
// //             <li
// //               className={`titlelist ${isMenuItemActive(href) && "active"}`}
// //               key={href}
// //             >
// //               <Link href={href} legacyBehavior>
// //                 <a className="spantitle">{title}</a>
// //               </Link>
// //             </li>
// //           ))}
// //         </ul>

// //         <ul className="dashboardcontents">
// //           {unmenu.map(({ href, title }) => (
// //             <li
// //               className={`untitlelist ${isMenuItemActive(href) && "active"}`}
// //               key={href}
// //             >
// //               <Link href={href} legacyBehavior>
// //                 <a className="unspantitle">{title}</a>
// //               </Link>
// //             </li>
// //           ))}
// //         </ul>
// //         <ul className="dashboardcontents">
// //           {unmenu.map(({ href, title }) => (
// //             <li
// //               className={`untitlelist ${isMenuItemActive(href) && "active"}`}
// //               key={href}
// //             >
// //               <Link href={href} legacyBehavior>
// //                 <a className="unspantitle">{title}</a>
// //               </Link>
// //             </li>
// //           ))}
// //         </ul>
// //         <ul className="dashboardcontents">
// //           {unmenu.map(({ href, title }) => (
// //             <li
// //               className={`untitlelist ${isMenuItemActive(href) && "active"}`}
// //               key={href}
// //             >
// //               <Link href={href} legacyBehavior>
// //                 <a className="unspantitle">{title}</a>
// //               </Link>
// //             </li>
// //           ))}
// //         </ul>

// //         <div className="profile-menu-container">
// //           <ul className="dashboardlogout">
// //             <div>
// //               {profilemenu.map(({ title1, className, dropdownItems }) => (
// //                 <li className={`titlelogoutlist`} key={title1}>
// //                   <div className="profile-menu">
// //                     <span
// //                       onMouseOver={() =>
// //                         setIsProfileMenuOpen(!isProfileMenuOpen)
// //                       }
// //                     >
// //                       {title1}
// //                     </span>
// //                     {isProfileMenuOpen && (
// //                       <ul className="dropdown-menu">
// //                         {dropdownItems.map(({ title, href }) => (
// //                           <li key={href}>
// //                             <Link href={href} legacyBehavior>
// //                               <a onClick={href === "/" ? handleLogout : null}>
// //                                 {title}
// //                               </a>
// //                             </Link>
// //                           </li>
// //                         ))}
// //                       </ul>
// //                     )}
// //                   </div>
// //                 </li>
// //               ))}
// //             </div>
// //           </ul>
// //         </div>
// //       </header>
// //       <div className={`${isHovered ? "hovered" : ""}`}>
// //         <nav></nav>
// //         <main className="flex-1">{children}</main>
// //       </div>
// //       <footer className="footer">Copyright © 2026 </footer>
// //     </div>
// //   );
// // }


// import Link from "next/link";
// import { useState } from "react";
// import { useRouter } from "next/router";
// //import opti from "/images/optic.png";
// import opti from "../images/optic.png";
// import Image from "next/image";
// import { CgProfile } from "react-icons/cg";
// import profile from "../images/profile.svg";
 
// export default function Layout({ children }) {
//   const router = useRouter();
//   const [isHovered, setIsHovered] = useState(false);
//   const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
 
 
// const menuItems = [
//   {
//     href: "/getallclientusers",
//     title: "Client Users",
//     subTags: ["/addclientuser","/edituser","/resetpasswordbyadmin","/changeclientuserpassword" ],
 
//   },
//   {
//     href: "/getAllConfig",
//     title: "Configuration",
//     subTags: ["/addconfig","/editconfig", ],
   
//   },
//   {
//     href: "/getallrules",
//     title: "Rules",
//     subTags: ["/addrule","/editpercentage","/editdynamic","/editstaticEwt","/editstaffinggeneral" ,"/editstaffing","/adduploadrule"],
   
//   },
//   {
//     href: "/getuploadconfig",
//     title: "Upload Config",
//     subTags: ["/addftp","/addazure","/addaws","/editftp","/editazure","/editaws" ],
   
//   },
//   {
//     href: "/getallforms",
//     title: "Forms",
//     subTags: ["/addqualityform","/editform" ],
   
//   }, {
//     href: "/getallint",
//     title: "ALL Interactions",
//     subTags: ["/playaudio","/scoring" ],
   
//   },
// ];
 
 
//   const unmenu = [
 
//   ];
 
//   const profilemenu = [
//     {
//       title1: <Image src={profile} className="imagepmlogo" alt="Profile Image" />,
//       className: "profile-menu-item",
//       dropdownItems: [
//         {
//           title: "Change Password",
//           href: "/resetpassword",
//         },
//         {
//           title: "Logout",
//           href: "/",
//         },
//       ],
//     },
//   ];
 
//   const isMenuItemActive = (href) => {
//     if (router.asPath === href) return true;
//     if (isProfileMenuActive()) return false;
//     const menuItem = menuItems.find((item) => item.href === href);
//     if (menuItem && menuItem.subTags) {
//       return menuItem.subTags.some(subTag => router.asPath.startsWith(subTag));
//     }
//     return false;
//   };
 
//   const isProfileMenuActive = () => {
//     return profilemenu.some(({ dropdownItems }) => {
//       if (!dropdownItems) return false;
//       return dropdownItems.some(({ href }) => router.asPath === href);
//     });
//   };
 
//   const handleLogout = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     router.push("/");
//   };
 
//   return (
//     <div className="minscreen">
//       <header className="headercss">
//         <Image src={opti} className="imagelogo" alt="Opti Image" />
//         <div className="nav-center">
//           <ul className="dashboardcontents">
//             {menuItems.map(({ href, title }) => (
//               <li className={`titlelist ${isMenuItemActive(href) && "active"}`} key={href}>
//                 <Link href={href} legacyBehavior>
//                   <a className="spantitle">{title}</a>
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </div>
 
//         <div className="profile-menu-container">
//           <ul className="dashboardlogout">
//             <div>
//               {profilemenu.map(({ title1, className, dropdownItems }) => (
//                 <li className={`titlelogoutlist`} key={title1}>
//                   <div className="profile-menu">
//                     <span onMouseOver={() => setIsProfileMenuOpen(!isProfileMenuOpen)}>{title1}</span>
//                     {isProfileMenuOpen && (
//                       <ul className="dropdown-menu">
//                         {dropdownItems.map(({ title, href }) => (
//                           <li key={href}>
//                             <Link href={href} legacyBehavior>
//                               <a onClick={href === "/" ? handleLogout : null}>{title}</a>
//                             </Link>
//                           </li>
//                         ))}
//                       </ul>
//                     )}
//                   </div>
//                 </li>
//               ))}
//             </div>
//           </ul>
//         </div>
//       </header>
//       <div className={`${isHovered ? "hovered" : ""}`}>
//         <nav></nav>
//         <main className="flex-1">{children}</main>
//       </div>
//       <footer className="footer">Copyright © 2026 </footer>
//     </div>
//   );
// }
 
import Link from "next/link";
import { useState } from "react";
import { useRouter } from "next/router";
//import opti from "/images/optic.png";
import opti from "../images/optic.png";
import Image from "next/image";
import { CgProfile } from "react-icons/cg";
import profile from "../images/profile.svg";
 
export default function Layout({ children }) {
  const router = useRouter();
  const [isHovered, setIsHovered] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
 
 
const menuItems = [
  {
    href: "/getallclientusers",
    title: "Client Users",
    subTags: ["/addclientuser", "/editclientuser", "/edituser", "/resetpasswordbyadmin", "/changeclientuserpassword"],
 
  },
  {
    href: "/getAllConfig",
    title: "Configuration",
    subTags: ["/addconfig","/editconfig", ],
   
  },
  {
    href: "/getallrules",
    title: "Rules",
    subTags: ["/addrule", "/editrule", "/editpercentage", "/editdynamic", "/editstaticEwt", "/editstaffinggeneral", "/editstaffing", "/adduploadrule"],
   
  },
  {
    href: "/getuploadconfig",
    title: "Upload Config",
    subTags: ["/addftp","/addazure","/addaws","/editftp","/editazure","/editaws" ],
   
  },
  {
    href: "/getallforms",
    title: "Forms",
    subTags: ["/addqualityform","/editform" ],
   
  }, {
    href: "/getallint",
    title: "ALL Interactions",
    subTags: ["/playaudio","/scoring" ],
   
  },
];
 
 
  const unmenu = [
 
  ];
 
  const profilemenu = [
    {
      title1: <Image src={profile} className="imagepmlogo" alt="Profile Image" />,
      className: "profile-menu-item",
      dropdownItems: [
        {
          title: "Change Password",
          href: "/resetpassword",
        },
        {
          title: "Logout",
          href: "/",
        },
      ],
    },
  ];
 
  const isMenuItemActive = (href) => {
    if (router.asPath === href || router.pathname === href) return true;
    if (isProfileMenuActive()) return false;
    const menuItem = menuItems.find((item) => item.href === href);
    if (menuItem && menuItem.subTags) {
      return menuItem.subTags.some(subTag => router.asPath.startsWith(subTag) || router.pathname.startsWith(subTag));
    }
    return false;
  };
 
  const isProfileMenuActive = () => {
    return profilemenu.some(({ dropdownItems }) => {
      if (!dropdownItems) return false;
      return dropdownItems.some(({ href }) => router.asPath === href || router.pathname === href);
    });
  };
 
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    router.push("/");
  };
 
  return (
    <div className="minscreen">
      <header className="headercss">
        <Image src={opti} className="imagelogo" alt="Opti Image" />
        <div className="nav-center">
          <ul className="dashboardcontents">
            {menuItems.map(({ href, title }) => (
              <li className={`titlelist ${isMenuItemActive(href) ? "active" : ""}`} key={href}>
                <Link href={href} legacyBehavior>
                  <a className="spantitle">{title}</a>
                </Link>
              </li>
            ))}
          </ul>
        </div>
 
        <div className="profile-menu-container">
          <ul className="dashboardlogout">
            <div>
              {profilemenu.map(({ title1, className, dropdownItems }) => (
                <li className={`titlelogoutlist`} key={title1}>
                  <div className="profile-menu">
                    <span onMouseOver={() => setIsProfileMenuOpen(!isProfileMenuOpen)}>{title1}</span>
                    {isProfileMenuOpen && (
                      <ul className="dropdown-menu">
                        {dropdownItems.map(({ title, href }) => (
                          <li key={href}>
                            <Link href={href} legacyBehavior>
                              <a onClick={href === "/" ? handleLogout : null}>{title}</a>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </li>
              ))}
            </div>
          </ul>
        </div>
      </header>
      <div className={`${isHovered ? "hovered" : ""}`}>
        <nav></nav>
        <main className="flex-1">{children}</main>
      </div>
      <footer className="footer">Copyright © 2026 </footer>
    </div>
  );
}
 
 